import request from "@/util/http";
import qs from "qs"; // 评分分页

export function queryRationPFVoList(obj) {
  return request({
    url: "/admin/tHallServeRation/queryRationPFVoList",
    method: "post",
    data: qs.stringify(obj)
  });
} // 好差评头部

export function queryRationHeadVo(params) {
  return request({
    url: "/admin/tHallServeRation/queryRationHeadVo",
    method: "get",
    params: params
  });
} // 好评top5

export function queryRationGoodVoList(obj) {
  return request({
    url: "/admin/tHallServeRation/queryRationGoodVoList",
    method: "post",
    data: qs.stringify(obj)
  });
} // 吐槽top5

export function queryRationTuCaoVoList(obj) {
  return request({
    url: "/admin/tHallServeRation/queryRationTuCaoVoList",
    method: "post",
    data: qs.stringify(obj)
  });
} // 提交整改

export function submitRationHandle(obj) {
  return request({
    url: "/admin/tHallServeRation/submitRationHandle",
    method: "post",
    data: obj
  });
}